import { makeAutoObservable } from "mobx";
import MobileDetect from "mobile-detect";

export type TRegion = {
  pid: number;
  cid: number;
  extName: number;
};

type TProvice = TRegion[];

class System {
  isMobile = false;
  isPad = false;
  isPc = false;
  isSafari = false;
  isAndroid = false;

  provice: TProvice = [];
  cities = new Map();

  constructor() {
    this.initial();
    makeAutoObservable(this);
  }

  initial() {
    const detecter = new MobileDetect(window.navigator.userAgent);
    this.isMobile = !!detecter.phone();
    this.isPad = !!detecter.tablet();
    this.isPc = !this.isMobile && !this.isPad;

    // if (window.screen.width >= 1100) {
    //   this.isPc = true;
    //   this.isPad = false;
    //   this.isMobile = false;
    // } else if (window.screen.width >= 768) {
    //   this.isPc = false;
    //   this.isPad = true;
    //   this.isMobile = false;
    // } else {
    //   this.isPc = false;
    //   this.isPad = false;
    //   this.isMobile = true;
    // }

    try {
      const userAgent = navigator.userAgent;
      this.isSafari = userAgent.indexOf("Safari") > -1;
      this.isAndroid =
        userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1;
    } catch (error) {
      console.log(error);
    }
  }
}

export default new System();
